<div id="line-item" class="panel" *ngIf="lineItems">
  <div class="panel-hdr">
    <h2>{{header}}</h2>
    <div class="panel-toolbar">
      <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen" data-toggle="tooltip"
              data-offset="0,10" data-original-title="Fullscreen"></button>
    </div>
  </div>
  <div class="panel-container show">
    <div class="panel-content">
      <div class="frame-wrap">

        <table class="table table-bordered table-sm">
          <tbody>
          <tr *ngFor="let lineItem of lineItems">
            <td>{{lineItem.title}}</td>
            <td>{{lineItem.value}} {{lineItem.unit}}</td>
          </tr>
          </tbody>
        </table>

      </div>
    </div>
  </div>
</div>





